'use client'

import ScrollLoad from '@/components/layout/scrollLoad'
import { CaseStudies } from '@/entities/caseStudies'
import { caseStudiesListAction } from '@/lib/actions/caseStudies'
import { caseStudiesPageSize } from '@/lib/config'
import { createContext, useContext } from 'react'
import { useAsyncFn, useList } from 'react-use'

const DataViewContext = createContext<{ data: CaseStudies[] }>({ data: [] })

export function DataViewContextProvider({
  data,
  total,
  query,
  index,
  children,
}: {
  data: CaseStudies[]
  total: number
  query?: string
  index: number
  children: React.ReactNode
}) {
  const [viewData, { push: pushData }] = useList(data)
  const [loadState, handleLoad] = useAsyncFn(async (pageIndex: number) => {
    debugger
    const res = await caseStudiesListAction(query, pageIndex)
    debugger
    pushData(...(res?.data || []))
  })

  return (
    <DataViewContext.Provider value={{ data: viewData }}>
      {children}
      <ScrollLoad
        initIndex={index}
        loading={loadState.loading}
        total={total}
        size={caseStudiesPageSize}
        onLoad={handleLoad}
        className='py-4'
      />
    </DataViewContext.Provider>
  )
}

export function useDataViewContext() {
  return useContext(DataViewContext)
}
